var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2428.1 2469.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        display: none;\n      }\n\n      .st0, .st1 {\n        fill: #282642;\n      }\n\n      .st2 {\n        fill: #ff4c60;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-2-copy-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B."
  }, /*#__PURE__*/React.createElement("path", {
    id: "B",
    className: "st0",
    d: "M609.2,2469.9c287.2,0,507.4-67,660.6-191.5,153.2-124.5,229.8-306.3,229.8-545.7s-28.7-229.8-95.7-325.5c-67-95.7-143.6-162.7-239.3-201,67-38.3,134-95.7,191.5-172.3,57.4-76.6,86.2-172.3,86.2-287.2,0-220.2-67-392.5-210.6-507.4-143.6-114.9-363.8-181.9-651-181.9H-482.1c-28.7,0-47.9,0-57.4,28.7-19.1,19.1-28.7,38.3-28.7,67h0v2240.1c0,19.1,0,47.9,28.7,57.4,19.1,19.1,38.3,28.7,57.4,28.7H609.2v-9.6ZM503.9,1005.2H73.1v-488.2h430.8c86.2,0,153.2,19.1,201,67,47.9,47.9,67,105.3,67,172.3s-19.1,134-67,181.9c-47.9,47.9-114.9,67-201,67h0ZM542.2,2000.8H73.1v-545.7h459.5c86.2,0,153.2,28.7,210.6,76.6,57.4,47.9,76.6,114.9,76.6,191.5s-28.7,143.6-76.6,191.5-114.9,76.6-210.6,76.6h0l9.6,9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1298.5,2249.7c-153.8,122.2-344.6,191.5-612.7,191.5s-430.8-57.4-631.8-181.9c-57.4-38.3-67-86.2-38.3-153.2l95.7-162.7c38.3-67,86.2-76.6,153.2-38.3,134,86.2,258.5,124.5,363.8,124.5s201-38.3,268.1-105.3c67-67,95.7-181.9,95.7-344.6V114.9c0-76.6,38.3-114.9,114.9-114.9h296.8c76.6,0,114.9,38.3,114.9,114.9v1493.4h0c.4,385.1-93.6,540.9-220.2,641.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_.",
    className: "st2",
    d: "M2342,2469.9c28.7,0,47.9,0,57.4-28.7,19.1-19.1,28.7-38.3,28.7-57.4h0v-459.5c0-28.7,0-47.9-28.7-67-19.1-19.1-38.3-28.7-57.4-28.7h-459.5c-28.7,0-47.9,0-67,28.7-19.1,19.1-28.7,38.3-28.7,67h0v459.5c0,28.7,0,47.9,28.7,57.4,19.1,19.1,38.3,28.7,67,28.7,0,0,459.5,0,459.5,0Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightLogo);
export default __webpack_public_path__ + "static/media/light-logo.12b56bb7c342712ec1380dd8116e99cb.svg";
export { ForwardRef as ReactComponent };